export default "__VITE_ASSET__12d8f464__"